// Escape a single CSV cell value.
export function csvCell(v) {
  if (v === null || v === undefined) return '';
  const s = String(v);
  return /[",\n]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s;
}

// Download arbitrary text as a file. CSVs get a UTF-8 BOM so Excel decodes
// accented names and symbols (—, ×, é…) correctly instead of mojibake.
export function downloadText(filename, text, mime = 'text/plain') {
  const BOM = String.fromCharCode(0xFEFF);
  const parts = /csv/i.test(mime) ? [BOM, text] : [text];
  const blob = new Blob(parts, { type: `${mime};charset=utf-8;` });
  const link = document.createElement('a');
  link.href = URL.createObjectURL(blob);
  link.download = filename;
  link.click();
  URL.revokeObjectURL(link.href);
}
